import { DisplayedRatePlanCode } from './displayed-rate-plan-code';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pioneer-rate-plan-code',
  templateUrl: './rate-plan-code.component.html',
  styleUrls: ['./rate-plan-code.component.css']
})
export class RatePlanCodeComponent implements OnInit {

  @Input() showCloseIcon: boolean;
  @Input() ratePlanCodes: DisplayedRatePlanCode;

  @Output() delete = new EventEmitter();

  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  removeRate(index: number) {
    this.delete.emit(index);
  }

  getTitleFromRpc(rpc: DisplayedRatePlanCode): string {
    return !rpc.closeable ? this.translate.instant('EVENT.RATE_PLAN_CODE_IN_USE') : undefined;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rate-plan-code/rate-plan-code/rate-plan-code.component.ts